import en from './en-US'
import ru from './ru-RU'
import zh from './zh-CN'

export const messages = { ru, en, zh }

export const locales = [
  {
    code: 'ru',
    iso: 'ru',
    name: 'Русский'
  },
  {
    code: 'en',
    iso: 'en',
    name: 'English'
  },
  {
    code: 'zh',
    iso: 'zh-hant',
    name: '中文(简体)'
  }
]

export const config = {
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: { ru, en, zh }
}
